<script setup>
    import { request } from 'graphql-request';
    import { inject, reactive, ref, watchEffect } from 'vue';
    import useCurrentLocale from '@Common/Composables/current-locale';
    import * as Sentry from "@sentry/vue";

    const props = defineProps({
        first: { type: Number, default: 10 },
        last: { type: Number, default: 0 },
    });

    const variables = reactive({
        first: props.first,
        last: props.last,
        after: null,
        before: null,
    });
    const isLoading = ref(true);
    const queryData = ref(null);
    const aggregatedData = ref({});
    const { urlWithLocale } = useCurrentLocale();
    const query = inject('query');

    const mergeData = (data) => {
        if (data) {
            Object.keys(data).forEach((key) => {
                if (aggregatedData.value[key] && aggregatedData.value[key].edges && data[key].edges) {
                    aggregatedData.value[key].edges = aggregatedData.value[key].edges.concat(data[key].edges);
                } else {
                    aggregatedData.value[key] = data[key];
                }
            });
        }
    };

    const requestQuery = async () => {
        if (query.value) {
            try {
                isLoading.value = true;
                queryData.value = await request(urlWithLocale.value('/:locale/graphql'), query.value, variables);
                mergeData(queryData.value);
            } catch (error) {
                console.error(JSON.parse(JSON.stringify(error)));
            }
            isLoading.value = false;
        }
    };

    watchEffect(() => {
        if (query.value && !queryData.value) {
            requestQuery();
        }
    });

    const fetchNext = (size, cursor) => {
        variables.first = size;
        variables.after = cursor;
        variables.last = null;
        variables.before = null;
        requestQuery();
    };

    const fetchPrevious = (size, cursor) => {
        variables.last = size;
        variables.before = cursor;
        variables.first = null;
        variables.after = null;
        requestQuery();
    };
</script>
<template>
    <div>
        <slot
            :queryData="queryData"
            :aggregatedData="aggregatedData"
            :fetchNext="fetchNext"
            :fetchPrevious="fetchPrevious"
            :isLoading="isLoading"
        />
    </div>
</template>